import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';


import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { PushNotifiPushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';
import { Toast } from "@capacitor/toast";
import { ViewActiveOrderListModal } from './Modal_ViewActiveOrderList';
import { ViewOrderHistroyListModal } from './Modal_ViewOrderHistoryList';

import {DateRange} from '../../zInternal_Features/merchant/components/DateRange'


export function OrdersSlide(props) {


    let authClient_context = useContext(Auth_MerchantID_context);

    //alert('In CheckIn_CheckOutSlides')
    //alert(authClient_context.acctID);
    //alert(authClient_context.accessRights);
    //alert(authClient_context.accessRights[0]);

    const [acctID, setAcctID ] = useState(authClient_context.acctID);
    const [schema, setSchemaName] = useState(authClient_context.schema);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate()-30)));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate()+1)));

    let [startDate_display, setStartDate_display] = useState(false);
    let [endDate_display, setEndDate_display] = useState(false);

    let [numOfOrdersActive, setNumOfOrdersActive] = useState(0);
    let [numOfOrdersReserved, setNumOfOrdersReserved] = useState(0);
    let [numOfOrdersHistory, setNumOfOrdersHistory] = useState(0);

    let [searchGuestData, setSearchGuestData] = useState(null);

    let [viewActiveOrderListModal, setViewActiveOrderListModal] = useState(false);
    let [viewOrderHistoryListModal, setViewOrderHistoryListModal] = useState(false);


    let [notifications, setnotifications] = useState([]);

    function searchGuestDataHandler(e) {
        
        setSearchGuestData(e.target.value);
    }
     

    function reloadDates(event)
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: "74100_client_ordersActive",
                user: acctID,
                xStartDateRange: event[0],
                xEndDateRange: event[1],
                sessionID: sessionID,
            })

            
        }

    
        fetch(baseURL+'userAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setNumOfOrdersActive(cols[0]);
                    setNumOfOrdersReserved(cols[1]);
                    setNumOfOrdersHistory(cols[2]);
                }


                authClient_context.changeStartDateRange(event[0]);
                authClient_context.changeEndDateRange(event[1]);
            
                    setStartDate(new Date(event[0]));
                    setEndDate(new Date(event[1]));
                
        })

    }

    useEffect(() => {
        
        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

   }, []);

       //alert("TAB ORDERS");
    //alert(notifications);
    //alert(notifications.length);
    //alert(authClient_context.accessRights[0]);

    return (

        <IonContent>
            {notifications.length !== 0 &&
            <IonList>
                {notifications.map((notif) =>
                    <IonItem key={notif.id}>
                        <IonLabel>
                            <IonText>
                                <h3 className="notif-title">{notif.title}</h3>
                            </IonText>
                            <p>{notif.body}</p>
                        </IonLabel>
                    </IonItem>
                )}
                </IonList>}
            <IonItem>
                <IonGrid>
                    <DateRange setDate={(e) => reloadDates(e)} data={{
                    startDate: startDate, 
                    endDate: endDate
                    }}></DateRange>
                </IonGrid>
            </IonItem>
            <IonGrid >
                <IonRow>
                    <IonCol>
                        <h3>Active</h3>
                        <p > {numOfOrdersActive} </p>
                        <IonButton onClick={() => setViewActiveOrderListModal(true)}> View </IonButton>
                    </IonCol>
                    <IonCol>
                        <h3>Reserved</h3>
                        <p > {numOfOrdersReserved} </p>
                        <IonButton > View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <h3>Order History</h3>
                        <p > {numOfOrdersHistory} </p>
                        <IonButton onClick={() => setViewOrderHistoryListModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>


            {viewActiveOrderListModal == true && <ViewActiveOrderListModal openModal={ viewActiveOrderListModal } closeModal={() => setViewActiveOrderListModal(false)} startDate={startDate} endDate={endDate}></ViewActiveOrderListModal>}

            {viewOrderHistoryListModal == true && <ViewOrderHistroyListModal openModal={ viewOrderHistoryListModal } closeModal={() => setViewOrderHistoryListModal(false)} startDate={startDate} endDate={endDate}></ViewOrderHistroyListModal>}

        </IonContent>

    )
    //}   
}